import gql from 'graphql-tag'
// """查询订单列表(经销商)"""
export const findProfitSharings = gql`
  query($order: [ProfitSharingsFindOrder!], $paging: PagingQuery, $where: ProfitSharingsFindFilter) {
    findProfitSharings(
      order: $order,
      paging: $paging,
      where: $where
    ) {
      profitSharings {
        id
        transactionNumber
        profitSharingNumber
        timeEnd
        createdAt
        status
        totalPrice
        order {
          id
          orderNumber
          totalPrice
          createdAt
          dealer {
            realname
            user {
              phone
            }
          }
        }
      }
      paging {
        currentOffset
        take
        totalCount
      }
    }
  }
`

export const exportProfitSharingsList = gql`
  query($order: [ProfitSharingsFindOrder!],$where: ProfitSharingsFindFilter) {
    exportProfitSharingsList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
